<div class="row mt-2 no-gutters">
  <div class="col">
    <small><a>Admin Console</a></small>
  </div>
</div>

<div class="row align-items-center justify-content-center home-container no-gutters">
  <div class="col pl-0 pr-0">
    <div class="row text-center ml-1 mr-1 mt-4">
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/b2b.png" alt="Account Management"
          routerLink="/provider/account-management" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Account Management</span><br>
        <span class="font-nissan-brand-w01-light font-12">Manage dongles</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/users.png" alt="Admin Roles" routerLink="/provider/user-roles" /><br>
        <span class="font-nissan-brand-w01-bold font-14">User Roles</span><br>
        <span class="font-nissan-brand-w01-light font-12">Add or manage users</span>
      </div>
      <!-- <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/question.png" alt="Support" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Support</span><br>
        <span class="font-nissan-brand-w01-light font-12">Access support services</span>
      </div> -->
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/gear.png" alt="Settings" routerLink="/settings" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Settings</span><br>
        <span class="font-nissan-brand-w01-light font-12">Manage account & dongle settings</span>
      </div>
    </div>
  </div>
</div>